import * as React from 'react';
import classnames from 'classnames';
import { classes, st } from './BoxSelection.deprecated.st.css';
import { classes as optionClasses } from './Option.deprecated.st.css';
import { Option as BoxSelectionOption } from './Option';
import { NativeSelectorProvider } from './NativeSelector';
import { BoxSelectionBoxSize, BoxSelectionSelectionType, } from './types';
import { Fieldset } from '../internal/Fieldset';
import uniqueId from '../../common/uniqueId';
/** The box selection is used to give the user to select single or multiple boxes. */
export class BoxSelection extends React.Component {
    constructor(props) {
        super(props);
        this.childRefs = [];
        this._getNativeSelector = () => {
            const { children } = this.props;
            if (!children) {
                return BoxSelectionSelectionType.RADIO_BUTTON;
            }
            const enabledChildren = React.Children.toArray(children).filter((child) => React.isValidElement(child) &&
                !child.props.disabled);
            return enabledChildren.length === 1
                ? BoxSelectionSelectionType.CHECKBOX
                : BoxSelectionSelectionType.RADIO_BUTTON;
        };
        this._errorMessageId = uniqueId('error-message');
    }
    focus(index) {
        const refToFocus = typeof index === 'number'
            ? this.childRefs[index]
            : this.childRefs.find((ref) => ref.current.props.checked) ||
                this.childRefs[0];
        refToFocus?.current?.focus();
    }
    render() {
        const { className, children, size, name, onChange, vertical, inline, error, errorMessage, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, label, } = this.props;
        const isErrorMessageProvided = error && !!errorMessage;
        const stStates = {
            error,
            hasErrorMessage: !!errorMessage,
        };
        return (React.createElement(Fieldset, { errorMessage: isErrorMessageProvided && errorMessage, errorMessageId: this._errorMessageId, className: st(classes.root, stStates, className), dataHook: this.props['data-hook'], label: label },
            React.createElement("div", { className: classnames(classes.container, className, {
                    [classes.vertical]: vertical,
                    [classes.inline]: inline,
                }), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy },
                React.createElement(NativeSelectorProvider, { value: this._getNativeSelector() }, React.Children.map(children, (child, key) => {
                    this.childRefs[key] = child.ref || React.createRef();
                    return (React.isValidElement(child) &&
                        React.cloneElement(child, {
                            key,
                            name,
                            size,
                            onChange,
                            vertical,
                            ref: this.childRefs[key],
                            className: st(classes.item, child.props.className, isErrorMessageProvided ? optionClasses.error : ''),
                        }));
                })))));
    }
}
BoxSelection.displayName = 'BoxSelection';
BoxSelection.defaultProps = {
    size: BoxSelectionBoxSize.xLarge,
};
BoxSelection.Option = BoxSelectionOption;
//# sourceMappingURL=BoxSelection.js.map